require('./component-utils');

module.exports = 'component-utils';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/component-utils/src/index.js
 ** module id = 84
 ** module chunks = 1
 **/